import { render, staticRenderFns } from "./RequestVamNew.vue?vue&type=template&id=e89a4dcc&scoped=true&"
import script from "./RequestVamNew.vue?vue&type=script&lang=js&"
export * from "./RequestVamNew.vue?vue&type=script&lang=js&"
import style0 from "./RequestVamNew.vue?vue&type=style&index=0&id=e89a4dcc&scoped=true&lang=css&"
import style1 from "./RequestVamNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89a4dcc",
  null
  
)

export default component.exports